import { K1Information } from '@e3dc-react/icons'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { useChartDateBarContext, useLastTimeFetched } from 'src/Libs/chart-kit'
import { makeStyles } from 'tss-react/mui'
import { CostSavingChartWrapper } from './cost-savings-chart'
import { DASHBOARD_COST_SAVINGS_ID } from 'src/Libs/qa/ids'
import { useIsElementVisible } from 'src/Libs/navigation'

const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
  },
}))

interface CostSavingsProps {
  hide: boolean
}

export const COST_SAVINGS_CHART_MAIN_WRAPPER_ID = 'cost-saving-chart-loading-backdrop'

/**
 * Component which displays a paper/card which wraps cost saving statistics.
 */
const CostSavings: React.FC<CostSavingsProps> = ({ hide }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const historyDataFetchDate = useLastTimeFetched()
  const { setIsCostSavingChartVisible } = useChartDateBarContext()
  const { isVisible, ref: visibilityRef } = useIsElementVisible()

  useEffect(() => {
    setIsCostSavingChartVisible(isVisible && !hide)
  }, [isVisible, setIsCostSavingChartVisible, hide])

  const info = (
    <OptionalTooltipWrapper titleKey={t('dynamic-power-prices.cost-saving-card.tooltip-text')}>
      <K1Information />
    </OptionalTooltipWrapper>
  )

  if (hide) return null

  return (
    <Box id={COST_SAVINGS_CHART_MAIN_WRAPPER_ID} sx={{ position: 'relative' }}>
      <Paper
        title={t('dynamic-power-prices.cost-saving-card.title')}
        subTitle={historyDataFetchDate}
        headerChildren={info}
        className={classes.container}
        dataQa={DASHBOARD_COST_SAVINGS_ID}
      >
        <Box ref={visibilityRef}>
          <CostSavingChartWrapper />
        </Box>
      </Paper>
    </Box>
  )
}

export default CostSavings
